
































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";

import { getTimeSince } from "@/utils/date-helpers";
import { formatStringArgs } from "@/utils/string-helpers";

/**
 * Components
 */

/**
 * API
 */
import teamsAPI from "@/api/teams";
import usersAPI from "@/api/users";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import { GetCurrentUserResponse } from "@/api/users/get-current-user.response";
import DataFetcher from "@/components/_global/DataFetcher.vue";


/**
 * Mixins
 */

/**
 * Types
 */


/**
 * VueX Modules
 */
const profileModule = namespace("profile");
const teamModule = namespace("team");

/**
 * Team's premium page.
 */
@Component({
	components: {DataFetcher}
})
export default class TeamPremiumPage extends Vue {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	getTimeSince = getTimeSince;
	formatStringArgs = formatStringArgs;

	/// Attributes
	isLoading = false;
	teamInfos: GetOneTeamResponse | null = null;
	teamPremiumLevels: any[] | null = null;
	teamContributions: any | null = null;

	/// VueX Modules
	@profileModule.Action("fetchUserDetails")
	fetchUserDetails: any;

	@profileModule.State("userDetails")
	userDetails!: GetCurrentUserResponse;

	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	/// Methods
	async created() {
	}

	async fetch() {
		await this.fetchTeamInfos();
		await this.refreshContributions();
		await this.fetchTeamPremiumLevels();
	}

	async fetchTeamInfos() {
		const teamInfos = await teamsAPI.getTeamInfos(this.currentTeam.id);
		await this.$team.fetch(teamInfos);
	}

	async fetchTeamPremiumLevels() {
		this.teamPremiumLevels = await teamsAPI.getPremiumLevels();
	}

	async refreshContributions() {
		this.teamContributions = await usersAPI.getMyTeamContributions(this.currentTeam.id);
	}

	async handleRemoveBoostTeam() {
		this.isLoading = true;
		try {
			await usersAPI.removeContributionToTeam(this.currentTeam.id);
			await Promise.all([this.fetchUserDetails(), this.refreshContributions(), this.fetchTeamInfos()]);
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	async handleAddBoostTeam() {
		this.isLoading = true;
		try {
			await usersAPI.addContributionToTeam(this.currentTeam.id);
			await Promise.all([this.fetchUserDetails(), this.refreshContributions(), this.fetchTeamInfos()]);
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	get max() {
		return this.userDetails.premium.bonuses?.maxBoostCredits ?? 0;
	}

	get current() {
		return this.teamContributions.myContribution;
	}
}
